/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Report context provider
 */
import React from "react";
import { useTranslation } from "react-i18next";
import {
  IReportContext,
  ReportContext,
  useReportContextHook,
} from "./ReportContext";
let kpiList: string[] = [];
let projectList: string[] = [];
export const ReportCtxProvider: React.FC<{
  children: React.ReactNode;
}> = (props: { children: React.ReactNode }) => {
  const [ctxValue, setCtxValue] = React.useState(() => ({
    kpis: [],
    projects: [],
    getKpis: () => kpiList,
    getProjects: () => projectList,
    sendValue: <K extends keyof IReportContext>(
      name: K,
      value: IReportContext[K]
    ) => {
      if (name === "kpis") {
        kpiList = value as string[];
      }
      if (name === "projects") {
        projectList = value as string[];
      }
      /*
            setCtxValue(oldState => {
              return {
                ...oldState,
                [name]: value
              };
            });
            */
    },
  }));
  return (
    <ReportContext.Provider value={ctxValue}>
      {props?.children}
    </ReportContext.Provider>
  );
};
export const useReportContext = useReportContextHook;
